<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2 justify-center">
        {{ $t('setupMiner.title') }}
      </v-card-title>
      <v-card-text>
        <v-col class="pt-5">
          <v-row class="justify-center"><i>Stratum</i></v-row>
          <v-row class="justify-center" v-if="stratum"><strong>{{ stratum }}</strong></v-row>
          <v-row class="justify-center" v-if="stratum2"><strong>{{ stratum2 }}</strong></v-row>
          <v-row class="justify-center" v-if="stratum3"><strong>{{ stratum3 }}</strong></v-row>
          <v-row class="justify-center mt-5"><i>{{ $t('setupMiner.workerConfig') }}</i></v-row>
          <v-row class="justify-center mb-3" v-if="account"><strong class="ml-1">{{ account }}.worker_name</strong></v-row>
          <p class="text--disabled">{{ $t('setupMiner.workerHint') }}</p>
          <p class="text--disabled mb-0">{{ $t('setupMiner.passwordHint') }}</p>
        </v-col>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeDialog"
        >
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userService } from '@/services/UserService'

export default {
  props: ['show'],
  data () {
    return {
      dialog: false,
      stratum: null,
      stratum2: null,
      stratum3: null,
      account: null
    }
  },
  watch: {
    show (value) {
      if (value) {
        this.getStratumInfo()
      }
      this.dialog = value
    },
    dialog (value) {
      if (!value) this.$emit('closeDialog')
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
    },
    getStratumInfo () {
      userService.getStratumInfo().then(response => {
        this.account = response.account
        this.stratum = response.stratum
        this.stratum2 = response.stratum2
        this.stratum3 = response.stratum3
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
